<template>
  <v-container fluid>
    <Title v-if="bMostrarSeccion"  :title="titlePage" class="pt-2"></Title>
    <v-col class="white" >
      <BreadCrumb v-if="bMostrarSeccion"  :historyPages="historyPages"></BreadCrumb>
      <v-container class="under-sec-flat-gray">
        <v-container fluid class="py-3 px-2">
          <v-row class="no-gutters text-center d-flex justify-center align-center">
            <TitleInput :titleInput="'Proceso a importar'"></TitleInput>
            <v-col cols="6" sm="3" class="pa-1">
              <SelectInput
                :process-import="this.$store.state.processImport"
                :processes-import-names="importacion"
                :on-change-input="onChangeProcessImport"
                placeholder-input="Selecciona el proceso a importar">
              </SelectInput>
            </v-col>
            <v-col cols="6" sm="5" class="pa-1" v-if="stateHeadProcess() ? headImport !== '' : this.$store.state.processImport !== '' ">
              <BtnDownloadXls
                :visible="stateHeadProcess() ? headImport !== '' : this.$store.state.processImport !== '' "
                title="Descarga archivo base"
                :nameFile="this.$store.state.processImport"
                :fields="{headers}"
                :data="this.$store.state.processesImportNames"
                :headImport="headImport"
                refComponent="download-base-file">
              </BtnDownloadXls>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row class="no-gutters text-center d-flex justify-center align-center" v-if="stateHeadProcess()" >
            <TitleInput :titleInput="this.$store.state.selectedProcessImport.fields['Head']['LabelHead']"></TitleInput>
            <SelectInput
                :process-import="headImport"
                :processes-import-names="headImportNames"
                :on-change-input="onChangeHeadImport"
                :placeholder-input="`Selecciona el ${this.$store.state.selectedProcessImport.fields['Head']['LabelHead']} a importar`">
            </SelectInput>
          </v-row>
          <v-divider></v-divider>
          <v-row class="no-gutters text-center d-flex justify-center align-center mt-2" v-if="stateHeadProcess() ? headImport !== '' : this.$store.state.processImport !== '' ">
            <TitleInput class="align-center d-flex" :titleInput="'Archivo a cargar'"></TitleInput>
             <v-col cols="12" sm="8" class="pa-1">
              <BtnInputFile
                accept=".csv"
                id="input-file-csv"
                title="Añadir archivo"
                :on-data-load="this.onMountData"
                ></BtnInputFile>
                <v-col cols="12" class="pa-2">
                  <TextInformative title="El archivo seleccionado debe estar formato de comas CSV"></TextInformative>
                </v-col>
             </v-col>
          </v-row>
        </v-container>
        <v-container v-if="message.enable&&stateHeadProcess() ? headImport !== '' : this.$store.state.processImport !== '' ">
          <PopupInformative
            :title="message.title"
            colorBkgd="headforms"
            :description="message.message"></PopupInformative>
        </v-container>
        <v-container v-if="loading">
          <ProgressBar
              :title="txtProgressBar"
              :percent="loadPercent"
              colorBar="#9ADCFF"
              colorBkgd="white"
              :disabled="loading"
              heightBar="30"></ProgressBar>
        </v-container>
        <v-container v-if="stateHeadProcess() ? headImport !== '' : this.$store.state.processImport !== '' ">
          <v-card
              color="four"
              min-height="5em">
            <v-container class="d-flex justify-space-between align-center py-4 px-2">
                <h3 class="ntitlesdark--text font-weight-medium font-size-2">
                  {{ !modeImport ? 'Previsualiza el archivo' : 'Edita la informacion' }} a importar
                </h3>
                <div class="ml-auto">
                  <v-btn @click="changeModeImport" class="mx-1" fab small elevation="0" dense color="primary" >
                    <v-icon size="17px">{{!modeImport ? 'fa-edit' : 'fa-eye' }}</v-icon>
                  </v-btn>
                  <v-btn :disabled="!modeImport" @click="addColumnImport" class="mx-1" fab small elevation="0" dense color="primary" >
                    <v-icon>{{'fa-plus'}}</v-icon>
                  </v-btn>
                  <v-btn  @click="onEliminarFila" class="mx-1" fab small elevation="0" dense color="primary" v-if="bEstadoEliminar">
                    <v-icon>{{'fa-trash'}}</v-icon>
                  </v-btn>
                  
                </div>
            </v-container>
            <template v-if="modeImport === 0">
              <TablePreviewImport
                :headersTable="headers"
                :dataTable="datasetImport">
              </TablePreviewImport>
            </template>
            <template v-else>
              <TableEditImport
                :schemaProcess="schemaProcess"
                @onEliminarFilas="onDatosEliminar"
                :headersTable="headers"
                :dataTable="datasetImport">
              </TableEditImport>
            </template>
          </v-card>
        </v-container>
        <v-container class="pa-4" v-if="stateHeadProcess() ? headImport !== '' : this.$store.state.processImport !== '' ">
          <v-row justify="center" class="no-gutters">
            <!-- <Btn
              v-if="bMostrarSeccion"
              :callback-btn="goToBack"
              outlinedBtn
              colorBtn="buttondark"
              classBtn="px-md-16 py-md-6 text-capitalize"
              classText="fs-1_3 buttondark--text"
              elevationBtn="0"
              title="Cancelar">
            </Btn> -->
            <div class="mx-2"></div>
            <Btn :callback-btn="ApiImportingData"
              v-if="bMostrarSeccion"
              :disabled="disabledImport"
              depressedBtn
              lightBtn
              :colorBtn="disabledImport ? 'buttondark' : 'ntitlesdark' "
              :classBtn="`px-md-8 py-md-6 text-capitalize ${disabledImport ? '' : 'cur-initial'}`"
              classText="fs-1_3 white--text"
              elevation="0"
              :title="txtTitleContinue">
            </Btn>
            <v-col class="mt-2" cols="12">
              <div @click="onDownloadFile" v-if="enableDownloadErrors">
                <BtnDownloadLocalXls
                    :visible="enableDownloadErrors"
                    title="Descarga archivo con errores "
                    :nameFile="this.$store.state.processImport"
                    :fields="{headers}"
                    :dataErrors="setErrors"
                    refComponent="download-errors-file">
                </BtnDownloadLocalXls>
              </div>
            </v-col>
          </v-row>

        </v-container>
      </v-container>
    </v-col>
  </v-container>
</template>
<script>

import BreadCrumb from "@/components/Importacion/BreadCrumb";
import Title from "@/components/Importacion/Title";
import TitleInput from "@/components/Importacion/TitleInput";
import SelectInput from "@/components/Importacion/SelectInput";
import BtnDownloadXls from "@/components/Importacion/BtnDownloadXls";
import BtnInputFile from "@/components/Importacion/BtnInputFile";
import TextInformative from "@/components/Importacion/TextInformative";
import PopupInformative from "@/components/Importacion/PopupInformative";
import ProgressBar from "@/components/Importacion/ProgressBar";
import TablePreviewImport from "@/components/Importacion/TablePreviewImport";
import Btn from "@/components/Importacion/Btn";
import axiosServices from "@/services/axiosServices";
import TableEditImport from "@/components/Importacion/TableEditImport";
import Ajv from "ajv";
import localize from 'ajv-i18n/localize/es';
import BtnDownloadLocalXls from "@/components/Importacion/BtnDownloadLocalXls";
import { mapGetters } from 'vuex';

export default {
  name:"Import",
  components: {
    Btn,
    TablePreviewImport,
    TableEditImport,
    ProgressBar,
    PopupInformative,
    TextInformative,
    BtnInputFile,
    BtnDownloadXls,
    BtnDownloadLocalXls,
    SelectInput,
    BreadCrumb,
    Title,
    TitleInput
  },
  props:{
    bMostrarSeccion: {
      type: Boolean,
      default: true
    },
    sProceso: {
      type: String,
      default: ''
    }
  },
  methods: {
    onDatosEliminar(oDatos){
      this.bEstadoEliminar = oDatos.bEstado;
      this.aFilasEliminar= oDatos.aFilas;
    },
    onEliminarFila(){
      let aTempFilas = [];
      for (let i = 0; i < this.datasetImport.length; i++) {
        //validar si posicion se encuentra en la lista para eliminar
        let oTemp = this.aFilasEliminar.find(element => element == i);
        if(oTemp==undefined){
          aTempFilas.push(this.datasetImport[i]);
        }
      }
      //asignar los nuevos valores al array
      this.datasetImport=aTempFilas;
      this.bEstadoEliminar=false;
    },
    onChangeProcessImport: async function (item) {
      await this.onCleanData();
      await this.unMountTable()
      await this.$store.dispatch('saveProcessImport',item);
      await this.$store.dispatch('saveTimestampImport', Math.trunc(new Date()/1000)); // timestamp Key to save logs until change the process newly
      await this.$store.dispatch('saveSelectedProcessImport',this.$store.state.processesImport.filter((process) => process.nameProcess === this.$store.state.processImport)[0]);
      await this.onMountTable();
    },
    onChangeHeadImport: async function (item) {
      this.headImport = item;
      this.modeImport = 0;
      this.oHeadImport = this.setItemsHead[item];
      await this.onMountTable(true);
    },
    shrinkKeyObj:async function(dataMasterOut, field){
      let aFormat = [];

      await dataMasterOut.aData.forEach((data) => {
        aFormat.push(data[field.split(',')[0]]);
      });
      return aFormat;
    },
    onMountTable: async function(onlyHead) {
      if(this.$store.state.processImport !== "") {
        let setHeadersPr = [];
        let setProcessImport = this.$store.state.selectedProcessImport;
        let fieldsProcess = setProcessImport.fields;
        this.headProcess = fieldsProcess['Head'];
        let setHeaders =  fieldsProcess.Headers || [];
        let widthHeader = setHeaders.length * 2 + 'em';
        this.message = setProcessImport.message;
        let counter;
        let setTypesEditor = {
          'string': 'string',
          'number': 'number',
          'boolean': 'select',
          'date': 'date'
        };
        let setTypesSchema = {
          'string': 'string',
          'number': 'integer',
          'boolean': 'boolean',
          'date': 'string'
        };
        const schemaProcess = {
          type: "object",
          properties: {}, //Dictionary with properties
          required: [], // Array with titles of required fields
          additionalProperties: true
        };
        let schemaOptional = {
          type: "object",
          properties: {}, //Dictionary with properties
          required: [], // Array with titles of required fields
          additionalProperties: false
        };

        // * Get Data Head
        if(this.headProcess && this.headImportNames!== undefined && this.headImportNames.length === 0) {
          const dataHead = await this.onGetDataMaster(null, this.headProcess['TBHeadProcess'], `${this.headProcess['FieldTBHeadProcess']},${this.headProcess['FieldDatabaseHeadProcess']}`);
          let aItems = {};
          dataHead.aData.forEach((itemHead) => {
            aItems[itemHead[this.headProcess['FieldTBHeadProcess']]] = itemHead;
          });
          this.setItemsHead = aItems;
          this.headImportNames = await this.shrinkKeyObj(dataHead, this.headProcess['FieldTBHeadProcess']);
        }

        for (counter in setHeaders) {
          let headers = setHeaders[counter];
          let valueField = headers['Label'];
          if (headers['IsRequired']) {
            valueField = valueField+' *';
            schemaProcess.required.push(valueField);
          }

          schemaOptional.properties[valueField] = {type: setTypesSchema[headers['Type']], nullable: headers['IsRequired']};
          schemaProcess.properties[valueField] = {type: setTypesSchema[headers['Type']], pattern: `^((?!(!Error:)).)${!headers['IsRequired'] ? '*': '+'}$`, nullable: !headers['IsRequired']};

          let headerToPush = {
            text: valueField,
            value: valueField,
            TypeEditor: setTypesEditor[headers['Type']],
            IsRequired: headers['IsRequired'],
            Type: setTypesSchema[headers['Type']],
            class: 'header-dt',
            align: 'center',
            width: widthHeader
          };
          if(headers['IsMaster'] ) {
            schemaProcess.properties[valueField].type = headers['Type'];
            if(!onlyHead) {
              headerToPush.options = await this.shrinkKeyObj(await this.onGetDataMaster(null, headers['TBMaster'], headers['FieldInTbMaster']), headers['FieldInTbMaster']);
            } else {
              headerToPush.options = this.headers[counter].options;
            }
          }
          if(headers['Head']) {
            schemaProcess.properties[valueField].type = headers['Type'];
            headerToPush.options = await this.shrinkKeyObj(await this.onGetDataMaster(this.oHeadImport[`${this.headProcess['FieldDatabaseHeadProcess']}`], headers['TBMaster'], headers['FieldInTbMaster']), headers['FieldInTbMaster']);
          }
          setHeadersPr.push(headerToPush);
        }
        // * Add Header State
        setHeadersPr.push({
          text: "Estado",
          value: 'Estado',
          Type: "string",
          TypeEditor: "string",
          IsRequired: false,
          class: 'header-dt ',
          align: 'center',
          width: widthHeader,
          fixed: true,
          sortable: false

        });
        this.headers=setHeadersPr;
        this.schemaProcess=schemaProcess;
        this.schemaOptional=schemaOptional;
      }
    },
    onGetProcesses: async function () {
      let processes = [];
      try {
        await axiosServices.getConfiguration('processes', false, {}).then((process) => {
          processes = process.aData;
          if(process['nStatusCode'] !== 200) {
            throw("error");
          }
        }).catch((er) => {
          throw Error(er);
        });
      } catch (e) {
        await this.$swal({
          icon: `error`,
          title: `Contactar con el administrador`,
          showConfirmButton: true,
          showCloseButton: true,
        });
        throw ("Error");
      }
      let setNames = ['', ];
      let setProcesses = ['', ];
      processes.forEach(p => {
        let process = {};
        process.fields = [];
        process.fields = JSON.parse(p['fields'])
        process.message = JSON.parse(p['message']);
        process.nameProcess = p['name_process'];
        process.proccessExecute = p['proccess_execute'];
        setProcesses.push(process);
        setNames.push(p['name_process']);
        if(this.sProcesoSeteado === '') this.importacion.push(process.nameProcess)
      });
      await this.$store.dispatch('saveProcessesImport', setProcesses);
      await this.$store.dispatch('saveProcessesImportNames', setNames);
    },
    onDownloadFile: async function () {
      this.enableDownloadErrors = !this.enableDownloadErrors;
    },
    ApiImportingData: async function() {
      this.loadPercent = 0;
      if(this.stateHeadProcess()) {
        if(this.headImport === ''  ) {
          await this.$swal({
            icon: `error`,
            title: `Debes seleccionar una opción del campo ${this.headProcess['LabelHead']}`,
            showConfirmButton: true,
            showCloseButton: true,
          });
          throw Error('Required');
        }
      }
      this.loading  = true;
      const ajv = new Ajv({coerceTypes:true, allErrors: true}); // options can be passed, e.g. {allErrors: true}
      const validate = ajv.compile(this.schemaProcess);
      let countErrors = 0;
      let totalItems = this.datasetImport.length;
      let inc = 100/totalItems;
      this.txtProgressBar = `Validando ${totalItems * Object.keys(this.datasetImport[0]).length} campos`;
      this.datasetImport.forEach((item) => {
        this.loadPercent += inc/2;
        const valid = validate(item);
        if (!valid) {
          item.Estado = 'Error';
          countErrors++;
        } else {
          this.loadPercent += inc/2;
        }
      });
      if (countErrors > 0) {
        await this.$swal({
          timer: 2000,
          icon: `error`,
          title: `Tienes errores en ${countErrors} fila${countErrors > 1 ? 's' : ''}`,
          showConfirmButton: true,
          showCloseButton: true,
        });
      } else {
        await this.$swal({
          title: `Validacion exitosa`,
          html: '<div><h3>Pulsa <strong style="color: rgb(48, 133, 214)">continuar</strong> para almacenar la informacion en el servidor</h3></div>',
          showConfirmButton: true,
          showCancelButton: true,
          showCloseButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Continuar',
        }).then(function(result){
          if(result.dismiss === 'cancel'){
            throw new Error('Cancelar');
          }
        });
        this.loadPercent = 0;
        inc = 100 / totalItems;
        this.txtProgressBar = `Enviando ${totalItems * Object.keys(this.datasetImport[0]).length} campos`;
        let setErrors = [];
        let params = `process=${this.$store.state.processImport}`;
        if(this.headImport !== "")  {
          params = params+`&headValue=`+this.headImport;
        }
        for(let j = 0; j < totalItems; j++) {
          await this.sleep(500);
          this.loadPercent += inc;
          let bodyImportPetition = this.datasetImport[j];
          const aDataImport = await axiosServices.postConfiguration(
              '/processes/import',
              {'fields':bodyImportPetition, 'timestampImport': this.$store.state.timestampImport},
              false,
              params
              );
          this.datasetImport[j]['aHistory'] = aDataImport['aHistory'];
          this.datasetImport[j]['aData'] = aDataImport['aData'];
          if (aDataImport['nStatusCode'] === 200) {
            this.datasetImport[j]['Estado'] = 'Completado';
          } else {
            setErrors.push(this.datasetImport[j]);
            this.datasetImport[j]['Estado'] = 'Error';
          }
        }
        if(setErrors.length === 0) {
          await this.onCleanData()
          await this.unMountTable();
          await this.$swal({
            icon: `success`,
            title: `Importación finalizada con Exito`,
            showConfirmButton: true,
            confirmButtonText: 'Continuar',
            showCloseButton: true,
          });
        } else {
          this.enableDownloadErrors = true;
          this.setErrors = setErrors;
          await this.$swal({
            icon: `error`,
            title: `Error de importación`,
            showConfirmButton: true,
            confirmButtonText: 'Revisar',
            showCloseButton: true,
          });
        }
      }

      
    },
    onGetDataMaster: async function (database, table, field) {
      let dataMaster = [];
      let error = false;
      let setParams = `table_master=${table}&field_master=${field}`;
      if(typeof database == "string") {
        setParams = setParams+`&db_master=${database}`;
      }
      try {
        await axiosServices.getConfiguration('processes/master', false, setParams).then((dataMasterOut) => {
          dataMaster = dataMasterOut;
        });
      } catch (e) {
        error = e;
        throw Error(error);
      }
      return dataMaster;
    },
    unMountTable: async function() {
      await this.$store.dispatch('saveProcessImport',"");
      await this.$store.dispatch('saveSelectedProcessImport',[]);
    },
    onMountData: async function(data) {
      this.loading  = true;

      this.loadPercent = 0;
      const ajv = new Ajv({coerceTypes:false, allErrors: true}); // options can be passed, e.g. {allErrors: true}

      const validateOptional = ajv.compile(this.schemaOptional);
      let isInsertedLast = false;
      if(data.data[data.data.length-1] !== undefined) {
        isInsertedLast = data.data[data.data.length-1].Estado === "Insertado";
      }

      if(isInsertedLast || data.data.length > 0){
        // same file
        let setDataPreview = [];
        let countErrors = 0 ;
        let totalItems = data.data.length;
        let inc = 100/totalItems;
        this.txtProgressBar = `Importando ${totalItems} registros`;

        //variable para validar si se omitieron filas de insercion pq todas sus columnas generaron error
        let nFilasOmitidas = 0;
        data.data.forEach( (itemData, count)  => {
          const validOptional = validateOptional(itemData);
          if(validOptional){
            const isInserted = itemData.Estado === "Insertado";
            const validOptional = validateOptional(itemData);
            if(validOptional || isInserted) {
              let setData = {"Estado": '', 'idExpand': count};  // Error, Importado, Insertado
              this.loadPercent += inc;
              let nCantidadErrores=0;
              this.$store.state.selectedProcessImport.fields.Headers.forEach((field) => {
                let labelField=field['Label'];
                let valueField;
                if (field.IsRequired === false) {
                  valueField = itemData[labelField]
                  setData[labelField] = valueField;
                } else {
                  valueField = itemData[labelField + ' *']
                  setData[labelField + ' *'] = valueField;
                  if (field.Type === typeof valueField && valueField != null) {
                    setData["Estado"] = isInserted ? 'Insertado' : 'Importado';
                  } 
                  //validar si es fecha
                  else if(field.Type=='date'&&!isNaN(Date.parse(valueField))&&valueField.split('-').length==3){
                    setData["Estado"] = isInserted ? 'Insertado' : 'Importado';
                  }
                  else {
                    const sAltFieldError = `${this.$store.state.errorMessagesImport} ${valueField}`;
                    countErrors++;
                    let key = field.IsRequired ? labelField + ' *' : labelField;
                    setData[key] = sAltFieldError;
                    setData["Estado"] = 'Error';
                    nCantidadErrores++;
                  }
                }
              });

              //se valida que si toda la fila completa tiene errores se omite para la insersion de la importacion
              if(nCantidadErrores==this.$store.state.selectedProcessImport.fields.Headers.length){
                nFilasOmitidas++;
              }else{
                setDataPreview.push(setData);
              }
            } else if(!isInserted)  {
              this.$swal({
                icon:`success`,
                title:`Importación ${isInserted} con error en ${count}`,
                showConfirmButton: true,
                showCloseButton: true,
              });
            }
          } else {
            localize(validateOptional.errors);

            let setMsgError = [];
            let Mensaje = ''
            validateOptional.errors.forEach((itmError) => {
              Mensaje = itmError.message.indexOf('integer') >= 0 ? 'Este campo solo permite valores numericos': 
                        itmError.message.indexOf('string') >= 0 ? 'Este campo solo permite valores alfanumericos' : 
                        itmError.message.indexOf('boolean') >= 0 ? 'Este campo solo permite valores Si - NO': itmError.message

              setMsgError.push(`<li>${itmError.instancePath.replace(/^./, "")} -> ${Mensaje}</li>`);
            });
            this.$swal({
              icon:`error`,
              title:`El archivo cargado del proceso ${this.getProcessImport} presenta errores` ,
              html: `<ul><b>Fila ${count+1}</b>${setMsgError}</ul>`,
              showConfirmButton: true,
              showCloseButton: true,
              
            });
            throw("Eroor");
          }
        });
        if(countErrors === 0 ) {
          await this.$swal({
            icon: `success`,
            title: `Importación exitosa`,
            showConfirmButton: true,
            showCloseButton: true,

          });
        } else if(nFilasOmitidas>0){
          await this.$swal({
            icon: `info`,
            title: `Se omiti${nFilasOmitidas > 1 ? 'eron' : 'ó'} ${nFilasOmitidas} fila${nFilasOmitidas > 1 ? 's' : ''}`,
            showConfirmButton: true,
            showCloseButton: true,

          });
        }
        else if(!isInsertedLast) {
          await this.$swal({
            timer: 3000,
            icon: `error`,
            title: `Importación con ${countErrors} error${countErrors > 1 ? 'es' : ''}`,
            showConfirmButton: true,
            showCloseButton: true,
          });
        }
      this.loadPercent = 0;
      this.disabledImport = false;
      this.datasetImport = setDataPreview;
      }

    },
    onCleanData: async function () {
      this.headers = [];
      this.datasetImport = [];
      this.headImport= "";
      this.oHeadImport= {};
      this.setItemsHead= {};
      this.headImportNames = [];
      this.modeImport = 0;
      this.loadPercent = 0;
      this.loading  = false;
    },
    addColumnImport: async function () {
      this.disabledImport = false;
      let data = this.datasetImport.push({'Estado': 'Insertado', 'idExpand': this.datasetImport.length});
      await this.onMountData({data: data});
    },
    changeModeImport: async function () {
      this.modeImport = this.modeImport === 0 ? 1 : 0;
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    stateHeadProcess() {
      this.bHeadProcess = this.$store.state.selectedProcessImport && this.$store.state.selectedProcessImport.fields && this.$store.state.selectedProcessImport.fields['Head'];
      return this.bHeadProcess;
    },
    goToBack() {
      window.history.back();
    }

  },
  data() {
    this.onMountTable();

    return {
      bEstadoEliminar:false,
      aFilasEliminar:[],
      titlePage: "Importa tus archivos",
      loadPercent:0,
      sTitle: 'Generando informe...',
      setProccess: this.$store.state.processesImportNames,
      modeImport: 0,
      historyPages: [
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlInicio,
          disabled: false,
          href: '/',
        },
        {
          text: 'Configuración',
          disabled: false,
          href: 'DashBoard',
        },
        {
          text: 'Importación',
          disabled: true,
          href: 'Import',
        },
      ],
      loading: false,
      headers: [],
      schemaProcess: {},
      schemaOptional: {},
      datasetImport: [],
      disabledImport: true,
      message: {},
      headProcess: {},
      txtProgressBar: "Cargando",
      enableDownloadErrors: false,
      setErrors: [],
      txtTitleContinue: 'Validar información',
      headImport: "",
      oHeadImport: {},
      setItemsHead: {},
      headImportNames: [],
      aHeadImportMap: [],
      bHeadProcess: false,
      importacion: [],
      sProcesoSeteado: ''
    }
  },
  mounted () {
    this.$store.state.processImport = ''
    this.$store.state.selectedProcessImport = {}
    this.onMountTable();
    this.onGetProcesses();
    if(this.$route.params.Caso !== undefined){
      this.sProcesoSeteado = this.$route.params.Caso
      this.importacion.push(this.sProcesoSeteado);
    }

    if(this.sProceso !== ''){
      this.sProcesoSeteado = this.sProceso
      this.importacion.push(this.sProcesoSeteado);
    }
  },
  computed: {
    ...mapGetters(['getProcessImport'])
  },
  watch:{
    loadPercent(){
      //validar que si el porcentaje es mayor a 100 pasarlo a 100
      if(this.loadPercent>100){
        this.loadPercent=100;
      }
    }
  }
}
</script>

<style lang="scss">
.v-chip {
  width: 100%;
  padding: 0 20%;

  .v-chip__content {
    text-align: center;
    margin: auto;
  }
}

.header-dt span {
  color: #012362;
  font-size: 1.2em;
  font-weight: 900;
}
.mytable {
  table {
    tr {
      td {
        padding: 1.2px 0 !important;
        color: rgb(44,42,42);
        font-size: .6em !important;
      }
    }
  }
}
.v-data-table td {
  font-size: 2em;
}

a {
  text-decoration: underline;
}
</style>